import React from 'react'
import styled from 'styled-components'
import { Router } from '@reach/router'
import Play from './Play'
import Intro from './Intro'

export default function App() {
  return (
    <StyledWrapper>
      <Router>
        <Intro path="/" />
        <Play path="play" />
      </Router>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  height: 100%;

  > div {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`
